$(document).on('change-counter', '#form-rent-request[data-type="8h"] [data-cart="qty"]', function (e, data) {
	let $container = $(this),
		$input = $container.find('input'),
		val = data.value,
		price8h = $container.data('price_8h'),
		priceAdditionalHour = $container.data('price_additional_hour')
	;

	let $totalValue = $(this).closest('#form-rent-request').find('[data-total]');

	let priceResult = price8h + priceAdditionalHour * val;
	$totalValue.text(output_numbers(priceResult));
});

$(document).on('input', '#form-rent-request[data-type="8h"] [data-cart="qty"] input', function (e, data) {
	let $container = $(this).closest('[data-cart="qty"]');
	let val = parseInt($(this).val());
	let min = parseInt($(this).attr('min'));
	let max = parseInt($(this).attr('max'));

	if (val < min) val = min;
	if (val > max) val = max;

	if ($(this).val() != val) {
		$(this).val(val);
	}

	$container.trigger('change-counter', [{
		value: val
	}]);
});

